module.exports = __webpack_public_path__ + "static/media/comparitive-stats.5ca6b2ba.png";